import "./index.scss";

import { BellCorpStudioLogoContainer } from "../../common-utilities/Bellcorp-Studio-Logo";
import IntranetHeader from "../../../core/header";
import HomeRedirect from "../../common-utilities/core/home-redirect";
import { tokenMainKeys, appSlugs } from "../../../utils/constants";
import { Stack } from "rsuite";

const MainContainer = ({
  token = tokenMainKeys.invoiceTracking,
  slug = appSlugs.invoiceTracking,
  children,
}) => {
  return (
    <>
      <div className="main-container">
        <IntranetHeader />
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          className="side-nav-header"
        >
          <HomeRedirect localstorageKey={token} />
          <h4>Operations KPI</h4>
        </Stack>

        <div className="main-right-container">
          <div className="content-div">
            <div>{children}</div>
            <BellCorpStudioLogoContainer />
          </div>
        </div>
      </div>
    </>
  );
};

export default MainContainer;
